'use client';

import { useEffect } from 'react';
import { useModalContext } from './modal-context';
import { useModalsStore } from './store';

type Props = {
    modalId: number;
    enabled: boolean;
};
export const ModalEscKeyHandler = ({ modalId, enabled }: Props) => {
    const data = useModalsStore((s) => s.data);
    const { onClose } = useModalContext();
    const dataEntries = Object.entries(data);
    const isLatestModal = parseInt(dataEntries[dataEntries.length - 1]?.[0]) === modalId;

    useEffect(() => {
        if (!enabled || !isLatestModal) {
            return;
        }

        const { document } = globalThis;

        const handleKeyDown = (event: KeyboardEvent) => {
            if (event.key === 'Escape') {
                onClose('esc');
            }
        };

        document.addEventListener('keydown', handleKeyDown);

        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [enabled, isLatestModal, onClose]);

    return null;
};
